import { createFileRoute } from '@tanstack/react-router';
import { queryClient } from '@/lib/utils/queryClient';
import { CompanyRuleQuotaTab } from '../../../-components/CompanyRuleQuotaTab';
import { companyRuleQuotaQueryOptions } from '../../../-hooks/useCompanyRuleQuota';

export const Route = createFileRoute(
  '/management/companies/(pages)/$companyId/automation-rules/',
)({
  loader: ({ params }) =>
    queryClient
      .ensureQueryData(companyRuleQuotaQueryOptions(params.companyId))
      .catch(() => undefined),
  component: CompanyRuleQuotaPage,
});

function CompanyRuleQuotaPage() {
  const { companyId } = Route.useParams();
  return <CompanyRuleQuotaTab companyId={companyId} />;
}
